import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import _ from 'underscore';
import {
  TargetingType,
  SettingsView,
  TargetingSettingsContext
} from '@bingads-webui-campaign/targeting-settings-scaffolds';

export class EditCampaignSettingsView extends SettingsView {
  initialize({
    campaignId,
    perfMarker,
    ccJsData,
    deps,
    serverContext,
    scopeServiceScope,
  }) {
    super.initialize({
      campaignId,
      setting: TargetingType.AllSettings,
      serverContext,
      scopeServiceScope,
    });

    const campaign = TargetingSettingsContext.pageContext.CurrentCampaign;
    const id = _.result(campaign, 'Id');
    const campaignViewMap = {
      default: TargetingSettingsContext.editCampaignPage,
      shopping: TargetingSettingsContext.editShoppingCampaignPage,
      smartShopping: TargetingSettingsContext.editSmartShoppingCampaignPage,
      audienceShopping: TargetingSettingsContext.editShoppingCampaignPage,
    };
    const EditPage = campaignViewMap[this.getEditPageViewType(campaign)];

    const EditPageWrapper = class extends DeterministicWrapperView {
      viewFactory() {
        return new EditPage({
          campaignId: id,
          deps,
          perfMarker,
          ccJsData,
          serverContext,
          scope: scopeServiceScope,
        });
      }
    };

    this.setChild('settings-container', new EditPageWrapper());
  }

  /**
   * Class name of the root element
   * @type {string}
   * @override
   */
  get className() { return 'edit-campaign-settings-view'; }

  getEditPageViewType(campaign) {
    const providerId = _.result(_.take(campaign.CampaignSettings), 'ProviderId');
    const campaignType = _.result(campaign, 'CampaignType');
    const campaignSubType = _.result(campaign, 'CampaignSubType');
    const isShoppingCampaign = (campaignType === 2);
    const isSmartShoppingCampaign = isShoppingCampaign && campaignSubType === 12;
    const isAudienceShoppingCampaign = (campaignType === 8) && providerId;

    let resultType = 'default';
    if (isShoppingCampaign) {
      if (isSmartShoppingCampaign) {
        resultType = 'smartShopping';
      } else {
        resultType = 'shopping';
      }
    } else if (isAudienceShoppingCampaign) {
      resultType = 'audienceShopping';
    } else {
      resultType = 'default';
    }

    return resultType;
  }
}
